import { render, staticRenderFns } from "./AppointmentConfirmation.vue?vue&type=template&id=c42b34d6&scoped=true"
import script from "./AppointmentConfirmation.vue?vue&type=script&lang=js"
export * from "./AppointmentConfirmation.vue?vue&type=script&lang=js"
import style0 from "./AppointmentConfirmation.vue?vue&type=style&index=0&id=c42b34d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42b34d6",
  null
  
)

export default component.exports